import { render, staticRenderFns } from "./dynamic-previewImg.vue?vue&type=template&id=6cad4c5b&scoped=true&"
import script from "./dynamic-previewImg.vue?vue&type=script&lang=js&"
export * from "./dynamic-previewImg.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-previewImg.vue?vue&type=style&index=0&id=6cad4c5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad4c5b",
  null
  
)

export default component.exports